module.exports = __webpack_public_path__ + "img/20190628161053QQ截图20190624162252.9b4e1e5e.png";